import DoctorConsultation from '../../doctor/consultation/Consultation';

const HospitalConsultation = () => {
  return <DoctorConsultation />;
};

export default HospitalConsultation;
